<template>
    <div :class="{hidden: !loading}">
        <loading></loading>
    </div>

    <form action="" class="form form--floating-label" :class="{hidden: loading}" @submit.prevent="formSubmit" ref='form' >
        <div class="input-container input-container--floating relative h-12 mb-5 " :class="{empty: !formData.first_name, error: submittedOnce && errors.first_name}">
            <input
                    id="first_name"
                    type="text"
                    v-model="formData.first_name"
                    class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue "
            />
            <label for="first_name" class="absolute left-2 transition-all px-1 text-blue-gray">
                First Name
            </label>
        </div>

        <div class="input-container input-container--floating relative h-12 mb-5 " :class="{empty: !formData.last_name, error: submittedOnce && errors.last_name}">
            <input
                    id="last_name"
                    type="text"
                    v-model="formData.last_name"
                    class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue "
            />
            <label for="last_name" class="absolute left-2 transition-all px-1 text-blue-gray">
                Last Name
            </label>
        </div>

        <div class="input-container input-container--floating relative h-12 mb-5 " :class="{empty: !formData.company, error: submittedOnce && errors.company}">
            <input
                    id="company"
                    type="text"
                    v-model="formData.company"
                    class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue "
            />
            <label for="company" class="absolute left-2 transition-all px-1 text-blue-gray">
                Company
            </label>
        </div>

        <div class="input-container input-container--floating relative h-12 mb-5 " :class="{empty: !formData.account_number, error: submittedOnce && errors.account_number}">
            <input
                    id="account_number"
                    type="text"
                    v-model="formData.account_number"
                    class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue "
            />
            <label for="company" class="absolute left-2 transition-all px-1 text-blue-gray">
                Account Number
            </label>
        </div>

        <div class="input-container input-container--floating relative h-12 mb-5 " :class="{empty: !formData.email, error: submittedOnce && errors.email}">
            <input
                    id="email"
                    type="email"
                    v-model="formData.email"
                    class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue"
            />
            <label for="email" class="absolute left-2 transition-all px-1 text-blue-gray">
                Email
            </label>
        </div>

        <div class="input-container input-container--floating relative h-12 mb-5 " :class="{empty: !formData.phone , error: submittedOnce && errors.phone}">
            <input
                    id="phone"
                    type="text"
                    v-model="formData.phone"
                    class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue"
            />
            <label for="phone" class="absolute left-2 transition-all px-1 text-blue-gray">
                Contact Phone
            </label>
        </div>


        <div v-if="submittedOnce && errors.message" class="bg-red text-white mt-10 mb-5 px-3 py-2 rounded ">
            {{ errors.message }}
        </div>

        <div class="mt-10 flex items-center ">
            <button type="submit" class="btn">Request Access</button>

            <router-link
                    :to="{ name: 'signIn' }"
                    class="ml-4 text-red hover:text-red-hover font-light underline cursor-pointer">Cancel Form</router-link>
        </div>
    </form>
</template>

<script charset="utf-8">

import { values, join, get } from 'lodash';
import Loading from '../includes/Loading.vue';
import Vuex from 'vuex';

export default {


    data() {
        return {
            formData: {
                first_name: '',
                last_name: '',
                company: '',
                account_number: '',
                phone: '',
                email: ''
            },

            loading: false,
            submittedOnce: false,
            errors: {
                first_name: 'First name is required',
                phone: 'Phone need to have at least 7 numbers',
                email: 'Email is required'
            }
        }
    },

    components: {
        Loading
    },

    emits: ["submit-success"],

    watch: {
        formData: {
            handler(newVal){
                this.errors.message = '';
                this.errors.first_name = newVal.first_name ? '' : 'First name is required';
                this.errors.phone   = newVal.phone.length >= 7 ? '' : 'Phone need to have at least 7 numbers';
                this.errors.email   = newVal.email  ? '' : 'Email is required';
            },
            deep: true
        }
    },

    methods: {
        ...Vuex.mapActions('equipments', {
            createRequestAccess: 'createRequestAccess'
        }),

        formSubmit() {
            this.submittedOnce = true;
            this.errors.message = '';

            // do not submit if form has errors
            if (join(values(this.errors), '')) {
                return;
            }
            this.loading = true;
            let data = {
                'First Name': this.formData.first_name,
                'Last Name': this.formData.last_name,
                'Company': this.formData.company,
                'Account Number': this.formData.account_number,
                'Phone': this.formData.phone,
                'Email': this.formData.email,
            }

            this.createRequestAccess(data)
            .then(() => {
                this.loading = false;
                this.$emit('submit-success');
            }).catch(err => {
                this.loading = false;
                this.errors = {
                    message: get(err, 'response.data.errors.0.message')
                }
            });
        },
    }
}
</script>
